import { useGetTagsQuery } from 'services'

export const useGetFilterTags = (arg = undefined, props = {}) => {
    const { tagOptions, ...rest } = useGetTagsQuery(arg, {
        selectFromResult: ({ data, ...rest }) => {
            let arr = []
            if (data) {
                arr = data
                    .slice()
                    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
                arr.unshift('all')
            }
            return {
                tagOptions: arr.map(t => ({ label: t, value: t })),
                ...rest,
            }
        },
        ...props,
    })

    return { tagOptions, ...rest }
}
